module.exports = {
      id: "comm-finance-usage",
      viewBox: "0 0 245.601 29.882",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-finance",
      toString: function () {
        return this.url;
      }
    }